module.exports = __webpack_public_path__ + "img/PerksDropsmartProfileJoy.177357a3.png";